import { URLS } from "@constants/urls";
import api from "@helpers/api";
import { SettingsOfficeCreateType } from "@type/HRM/settings/settings-office";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/office-address`;

export const fetchSettingsOffice = async (query: any) => {
  const res = await api.get(`${apiEndPoint}`, {
    params: query,
  });

  return res;
};

export const fetchSettingsOfficeById = async (id: number | string) => {
  const res = await api.get(`${apiEndPoint}/${id}`);

  return res;
};

export const createSettingsOffice = async (data: SettingsOfficeCreateType) => {
  const res = await api.post(`${apiEndPoint}`, {
    ...data,
  });

  return res;
};

export const updateSettingsOffice = async (id: string | number, data: any) => {
  const res = await api.put(`${apiEndPoint}/${id}`, {
    ...data,
  });

  return res;
};

export const deleteSettingsOffice = async (id: string | number) => {
  const res = await api.delete(`${apiEndPoint}/${id}`);

  return res;
};
